<su-slot-dialog-title [title]="'welcome_pop_up.title' | translate" class="title-box"></su-slot-dialog-title>
<div class="container-pop-up">
  <div class="container-content">
    <p>
      {{ 'welcome_pop_up.content_message' | translate }}
    </p>
      <a (click)="redirectToLocation()" class="link">
        {{ 'welcome_pop_up.link_to_location' | translate }}
      </a>
  </div>
  <div class="checkbox-container">
    <mat-checkbox [(ngModel)]="checkboxCheckedValue">
      {{ 'welcome_pop_up.checkbox' | translate }}
    </mat-checkbox>
  </div>
  <div class="button-container">
    <su-button
      type="button"
      [skin]="'secondary'"
      (onClick)="closeWelcomePopUp()"
      [label]="'buildingMaintenance.labels.buttonCancel' | translate">
    </su-button>
    <su-button
      type="submit"
      [skin]="'primary'"
      [disabled]="!isSubmitEnabled()"
      (onClick)="submitWelcomePopUp()"
      [label]="'buildingMaintenance.labels.buttonSave' | translate">
    </su-button>
  </div>
</div>
